import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface PageLoaderProps {
  message?: string;
  className?: string;
}

export function PageLoader({ message, className }: PageLoaderProps) {
  return (
    <div
      data-slot="page-loader"
      className={cn(
        "flex min-h-[40vh] w-full flex-col items-center justify-center gap-3 text-muted-foreground",
        className,
      )}
      role="status"
      aria-busy="true"
      aria-label={message ?? "Loading"}
    >
      <Loader2 className="size-6 animate-spin text-primary" />
      {message ? <p className="text-sm">{message}</p> : null}
    </div>
  );
}
